import Service from '@ember/service';
import type { Scope } from '@sentry/types';

export interface ISentryUser {
  id: string;
  email: string;
}

// Returned when Sentry isn't loaded (e.g. test env). Methods are stubbed
// lazily via Proxy so any Scope API the addon would have offered no-ops.
const noopScope = new Proxy({} as Scope, {
  get: () => () => noopScope,
});

export default class SentryService extends Service {
  public configure(user: ISentryUser): void {
    window.Sentry?.setUser(user);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public captureException(error: any, context?) {
    window.Sentry?.captureException(error, context);
  }

  public captureMessage(message: string) {
    window.Sentry?.captureMessage(message);
  }

  public getCurrentScope(): Scope {
    return window.Sentry?.getCurrentScope() ?? noopScope;
  }
}

declare module '@ember/service' {
  interface Registry {
    sentry: SentryService;
  }
}
